import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { IccClaimImportsService } from 'app/core/services/icc/icc-claim-imports.service';
import { ImportUploadResult, IccImportUploadComponent } from '../../components/icc-import-upload/icc-import-upload.component';
import { HttpErrorResponse } from '@angular/common/http';
import { isEmpty } from 'lodash-es';
import { ImportNavComponent } from '../../../shared/components/import-nav/import-nav.component';


@Component({
    selector: 'app-icc-import-claims',
    templateUrl: './icc-import-claims.component.html',
    styleUrls: ['./icc-import-claims.component.scss'],
    imports: [ImportNavComponent, IccImportUploadComponent]
})
export class IccImportClaimsComponent {
  private claimImportsService = inject(IccClaimImportsService);
  private router = inject(Router);

  errors: string[] = [];

  onUploadComplete({ clientId, thirdPartyAdministerId, name, upload }: ImportUploadResult) {
    this.claimImportsService.create(clientId, thirdPartyAdministerId, name, upload.signedId).subscribe(
      () => {
        this.router.navigate(['/capture-admin/icc-claims/imports/claims/history']);
      },
      (error: HttpErrorResponse) => {
        this.errors = error.error.errors;
      }
    );
  }

  onUploadStart() {
    this.errors = [];
  }

  public get hasError() {
    return !isEmpty(this.errors);
  }
}
